module.exports = __webpack_public_path__ + "files/d9bee607e42329e3ae452342fd8500fb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-regular.svg
 ** module id = 980
 ** module chunks = 0
 **/